import styled from 'styled-components';

export const StyledCardTimelineSheet = styled.div`
.timeline {
    background: #ECF1F524;
    overflow: hidden;
    border-radius: 10px;
	label {
		font-family: Open Sans;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 22px;
		/* identical to box height */
		margin-left: 66px;
		margin-top: 10px;
		color: #FFFFFF;
	}

	.box {
		width: 100%;
		background: #fbfcfd;

		.container {
			width: 100%;
			display: flex;

			.lines {
                margin: 48px 14px 41px 5px;
				
                .dot {
                    width: 20px;
                    height: 20px;
                    background: #D1D6E6;
                    border-radius: 24px;
                }

                .dot-fill {
                    background: #2c3b82 !important;
                }

                .line:last-child {
                    display:none;
                }

				.line {
                    height: 45px;
                    width: 2px;
                    background: #D1D6E6;
                    margin-left: 9.3px;
				}

                .line-fill {
                    background: #2c3b82 !important;
                }
			}

			.cards {
                padding-top: 7px;
                z-index: 1;

				.card {
                    height: 53px;
                    background: #FFFFFF;
                    border-radius: 6px;
                    padding: 0.5rem;
                    text-align: left;
                    margin-top: 1rem !important;
                    white-space: nowrap !important;

					h4 {
                        font-style: normal;
                        font-weight: bold;
                        font-size: 11px;
                        line-height: 19px;
                        margin-bottom: 0px;
                        color: #2B2862;
					}

					p {
                        font-style: normal;
                        font-weight: normal;
                        font-size: 13px;
                        color: #2B2862;
                        display: flex;
                        justify-content: space-between;

                        .bg-primary {
                            background-color: rgb(216 234 248) !important;
                            color: #000;
                        }
					}
				}
			}

		}
	}
}

.card-menu-hide {
    background: black;
    color: #fff;
    margin: 1rem;
    font-size: 11px;
    display: none;
    width: 50%;
    padding: 5px;
    border-radius: 7px;
}
`